import React, { useState, useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//
import { Header } from "../../../common";
import { history } from "../../../../store/configure/configureStore";
import { FaBrush, FaPen } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import { VscPreview } from "react-icons/vsc";
import placeholderImageForUpload from "../../../../assets/images/placeholderImageForUpload.png";
//
import {
  CardView,
  ButtonView,
  ModalView,
  Input,
  Select,
  TagView,
  TextToInputView,
  ColorInput,
  Checkbox,
} from "../../../controls";
import { BannerPreview as Preview } from "../../../common";
// import Preview from "./components/Preview";
//
import "./AddBannerStyles.scss";

const AddBannerView = ({
  showModal,
  showImageResolutionWarningModal,
  showImageBackgroundColorModal,
  showColorModalOnClickIcon,
  //
  fields,
  newFields,
  editField,
  fileInput,
  device,
  imageBackgroundColor,
  showBackGroundColorIcon,
  showInputElement,
  errors,
  //
  subscriptionList,
  //
  handleDoubleClickText,
  handleInputToTextOnFocusOut,
  handleFileChange,
  handleDiscardFile,
  handleInputChange,
  handleInputChangeOfActiveModal,
  handleColorChange,
  handleBackgroundColorChange,
  handleVisibilityChange,
  handleStatusChange,
  handleDeviceChange,
  onChangeBannerScreenOption,
  handleCheckBoxChange,
  //
  deviceDropDownOptions,
  statusDropDownOptions,
  bannerScreenListDropDownOptions,
  //
  onClickSubmit,
  //
  handleShowModal,
  handleCloseModal,
  handleShowImageResolutionWarningModal,
  handleCloseImageResolutionWarningModal,
  handleShowImageBackgroundColorModal,
  handleOnClickIconShowImageBackgroundColorModal,
  handleOnClickIconConfirmImageBackgroundColorModal,
  // handleOnClickConfirmImageBackgroundColorModal,
  // handleCancelImageBackgroundColorModal,
  handleOnClickCancelImageBackgroundColorModal,
  handleOnSaveClick,
  handleOnClickCancel,
  //
  resetShowInputElement,
  //
  onClickCancel,
}) => {
  // console.log("device", device);
  const [modalTitle, setModalTitle] = useState("Edit");
  const [isButton, setIsButton] = useState(false);

  const getModalTitle = () => {
    // Find the active key
    const activeKey = Object.keys(newFields).find(
      (key) => newFields[key].active === true
    );

    // Set the modal title based on the active key
    if (activeKey) {
      setModalTitle(newFields[activeKey]?.modalTitle || "");
      setIsButton(newFields[activeKey]?.type === "button" ? true : false);
    } else {
      setModalTitle("");
    }
  };

  useEffect(() => {
    getModalTitle();
  }, [newFields]);

  const visibilityDropdownOptions = [
    { label: "show", value: "show" },
    { label: "hidden", value: "hidden" },
  ];

  const bannerRef = useRef(null);
  const [bannerDimensions, setBannerDimensions] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    // Measure the banner content size once it has mounted
    if (bannerRef.current) {
      const { offsetWidth, offsetHeight } = bannerRef.current;
      // console.log("width", offsetWidth, "height", offsetHeight);
      setBannerDimensions({ width: offsetWidth, height: offsetHeight });
    }
  }, [bannerRef]);

  const renderBannerContent = () => {
    return (
      <div className="banner-content-wrapper" ref={bannerRef}>
        <div
          className="image-block"
          style={{ backgroundColor: imageBackgroundColor }}
        >
          <div
            className={`file-input-block ${
              showBackGroundColorIcon && "editable-block"
            }`}
          >
            {showBackGroundColorIcon && (
              <div className="edit-background-color">
                <FaBrush
                  title="Edit background color"
                  size={15}
                  color="black"
                  onClick={() =>
                    handleOnClickIconShowImageBackgroundColorModal()
                  }
                />
              </div>
            )}
            <input
              type="file"
              id="actual-btn"
              onChange={(e) => handleFileChange(e, bannerDimensions)}
              accept="image/*"
              hidden
            />
            <label htmlFor="actual-btn" className="actual-btn-content">
              Upload Image
            </label>
          </div>
          <img
            className={
              !imageBackgroundColor &&
              // !showImageResolutionWarningModal &&
              // !showImageBackgroundColorModal &&
              "fill-full-width"
            }
            src={
              fileInput ? fileInput : placeholderImageForUpload
              // : "https://via.placeholder.com/600x400?text=Upload+Image"
            }
          />
          <div className="text-input-field-block ">
            <div className="text-content-wrapper">
              <TextToInputView
                name={"title"}
                // value={fields?.title}
                value={newFields?.title?.title}
                onChange={(e) => handleInputChange(e)}
                showInputElement={showInputElement.title}
                handleClick={() => handleDoubleClickText("title")}
                textString={newFields?.title?.title || "Enter Title here"}
                maxLength={"24"}
                iconOnEdge={
                  <FaPen
                    title="Edit"
                    size={15}
                    color="black"
                    onClick={() => handleShowModal("title")}
                  />
                }
                onBlur={() => resetShowInputElement()}
              />
            </div>
            <div className="text-content-wrapper">
              <TextToInputView
                name={"subTitle"}
                // value={fields?.subTitle}
                value={newFields?.subTitle?.subTitle}
                onChange={(e) => handleInputChange(e)}
                showInputElement={showInputElement.subTitle}
                handleClick={() => handleDoubleClickText("subTitle")}
                textString={
                  newFields?.subTitle?.subTitle || "Enter Sub-Title here"
                }
                maxLength={"16"}
                iconOnEdge={
                  <FaPen
                    title="Edit"
                    size={15}
                    color="black"
                    onClick={() => handleShowModal("subTitle")}
                  />
                }
                onBlur={() => resetShowInputElement()}
              />
            </div>
            <div className="text-content-wrapper action-content">
              <div className="action-primary">
                <TextToInputView
                  name={"primaryBtnTitle"}
                  // value={fields?.primaryBtnTitle}
                  value={newFields?.primaryBtnTitle?.primaryBtnTitle}
                  onChange={(e) => handleInputChange(e)}
                  showInputElement={showInputElement.primaryBtn}
                  handleClick={() => handleDoubleClickText("primaryBtn")}
                  textString={
                    newFields?.primaryBtnTitle?.primaryBtnTitle || "Button 1"
                  }
                  maxLength={"20"}
                  textExtraStyles={"btn-text"}
                  iconOnEdge={
                    <FaPen
                      title="Edit"
                      size={15}
                      color="black"
                      onClick={() => handleShowModal("primaryBtnTitle")}
                    />
                  }
                  onBlur={() => resetShowInputElement()}
                />
              </div>
              <div className="action-secondary">
                <TextToInputView
                  name={"secondaryBtnTitle"}
                  // value={fields?.secondaryBtnTitle}
                  value={newFields?.secondaryBtnTitle?.secondaryBtnTitle}
                  onChange={(e) => handleInputChange(e)}
                  showInputElement={showInputElement.secondaryBtn}
                  handleClick={() => handleDoubleClickText("secondaryBtn")}
                  textString={
                    newFields?.secondaryBtnTitle?.secondaryBtnTitle ||
                    "Button 2"
                  }
                  maxLength={"20"}
                  textExtraStyles={"btn-text"}
                  iconOnEdge={
                    <FaPen
                      title="Edit"
                      size={15}
                      color="black"
                      onClick={() => handleShowModal("secondaryBtnTitle")}
                    />
                  }
                  onBlur={() => resetShowInputElement()}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="information-block">
          Note: The image dimensions should be at least 1920 x 1080 pixels.
        </div>
      </div>
    );
  };

  const renderBannerPreviewContent = () => {
    return (
      <div className="preview-content-wrapper">
        <div className="preview-screen-selection-block">
          <Select
            label={"Preview"}
            options={deviceDropDownOptions}
            value={deviceDropDownOptions.find(
              (item) => item.label === device?.name
            )}
            placeholder={"select device"}
            onChange={handleDeviceChange}
            styles={{
              menuList: (baseStyles, state) => ({
                ...baseStyles,
                height: "200px",
                overflow: "auto",
              }),
            }}
          />
        </div>
        <div className="preview-content">
          <Preview
            imgSrc={fileInput}
            defaultImgSrc={
              "https://via.placeholder.com/600x400?text=Upload+Image"
            }
            title={newFields?.title}
            subTitle={newFields?.subTitle}
            primaryButton={newFields?.primaryBtnTitle}
            secondaryButton={newFields?.secondaryBtnTitle}
            device={device}
            //
            imageBackgroundColor={imageBackgroundColor}
            // showImageResolutionWarningModal={showImageResolutionWarningModal}
            // showImageBackgroundColorModal={showImageBackgroundColorModal}
          />
        </div>
      </div>
    );
  };

  //--------------------------Add modal UI
  const renderEditBody = () => {
    const { colorValue, visibilityValue, fontSize, BtnActionURL } = Object.keys(
      newFields
    ).reduce(
      (acc, key) => {
        if (newFields[key].active) {
          console.log(newFields[key].color, newFields[key].visibility);
          return {
            colorValue: newFields[key].color,
            visibilityValue: newFields[key].visibility,
            fontSize: newFields[key].fontSize,
            BtnActionURL: newFields[key].BtnActionURL,
          };
        }
        return acc;
      },
      { colorValue: "", visibilityValue: "", fontSize: "", BtnActionURL: "" }
    );

    return (
      <div className="body-content-wrapper">
        {isButton && (
          <div className="input-content-wrapper">
            <Input
              name="BtnActionURL"
              label={"Button Action URL"}
              value={BtnActionURL}
              // isrequired={true}
              onChange={(e) => handleInputChangeOfActiveModal(e)}
              placeholder={"Please Enter URL"}
              autocomplete="off"
            />
          </div>
        )}
        <div className="input-content-wrapper">
          <ColorInput
            name="color"
            label={"Color"}
            value={colorValue}
            placeholder="select color"
            // isrequired={true}
            onChange={handleColorChange}
            // error={errors["name"]}
            // autocomplete="new-name"
            autocomplete="off"
          />
        </div>
        <Row>
          <Col>
            <div className="input-content-wrapper">
              <Select
                name="visibility"
                label={"visibility"}
                value={visibilityValue}
                options={visibilityDropdownOptions}
                // isrequired={true}
                onChange={(val) => handleVisibilityChange(val)}
                placeholder={"Please select"}
                // error={errors["role"]}
              />
            </div>
          </Col>
          <Col>
            <div className="input-content-wrapper">
              <Input
                name="fontSize"
                label={"Font Size"}
                value={fontSize}
                // isrequired={true}
                onChange={(e) => handleInputChangeOfActiveModal(e)}
                placeholder={"Please Enter Font Size"}
                autocomplete="off"
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            size={"large"}
            // onClick={handleCloseModal}
            onClick={handleOnClickCancel}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Save"
            styles={"secondary"}
            size={"large"}
            onClick={() => handleOnSaveClick()}
          />
        </div>
      </div>
    );
  };

  //--------------------------resolution warning modal UI
  const renderImageResolutionWarningBody = () => {
    return (
      <div className="body-content-wrapper">
        <span className="mb-2">
          The dimensions of the uploaded image are below the required 1920 x
          1080 pixels. Would you like to keep it anyway?
        </span>
        {/* <div className="input-content-wrapper">
          <ColorInput
            name="color"
            label={"Color"}
            value={imageBackgroundColor}
            placeholder="select background color"
            // isrequired={true}
            onChange={handleBackgroundColorChange}
            // error={errors["name"]}
            // autocomplete="new-name"
            autocomplete="off"
          />
        </div> */}
      </div>
    );
  };

  const renderImageResolutionFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Yes"
            // disabled={!imageBackgroundColor && true}
            styles={"secondary"}
            size={"large"}
            // onClick={() => handleCloseImageResolutionWarningModal()}
            onClick={() => handleShowImageBackgroundColorModal()}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="No"
            styles={"light"}
            size={"large"}
            onClick={() => {
              handleCloseImageResolutionWarningModal();
              handleDiscardFile(); //reset the file state
            }}
          />
        </div>
      </div>
    );
  };

  //--------------------------image background color modal UI
  const renderImageBackgroundColorBody = () => {
    return (
      <div className="body-content-wrapper">
        <div className="input-content-wrapper">
          <ColorInput
            name="color"
            label={"Color"}
            value={imageBackgroundColor}
            placeholder="select background color"
            // isrequired={true}
            onChange={handleBackgroundColorChange}
            // error={errors["name"]}
            // autocomplete="new-name"
            autocomplete="off"
          />
        </div>
      </div>
    );
  };

  const renderImageBackgroundColorOnEditColorIconClickFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Confirm"
            disabled={!imageBackgroundColor && true}
            styles={"secondary"}
            size={"large"}
            onClick={() => handleOnClickIconConfirmImageBackgroundColorModal()}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            size={"large"}
            onClick={() => {
              handleOnClickCancelImageBackgroundColorModal();
            }}
          />
        </div>
      </div>
    );
  };

  const renderCheckList = () => {
    // Define the specific items to add
    const flagItems = [
      {
        _id: "sahaj-id",
        name: "Sahaj",
        isActive: true,
        isFlagItem: true,
      },
      {
        _id: "sky-id",
        name: "Sky",
        isActive: true,
        isFlagItem: true,
      },
    ];

    // Combine flag items with filtered subscription list
    const combinedList = [
      ...(subscriptionList?.filter((item) => item?.isActive) || []),
      ...flagItems,
    ];

    return (
      <div className="list-wrapper">
        {combinedList.map((item) => (
          <span className="list" key={item._id}>
            <Checkbox
              iconSize={10}
              text={item.name}
              onChange={(e) =>
                handleCheckBoxChange(
                  item._id,
                  item.name,
                  e.target.checked,
                  item?.isFlagItem // Pass isFlagItem property
                )
              }
            />
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="add_banner--container">
      <div className="add_banner--header-wrapper">
        <div className="action">
          <FaArrowLeftLong size={25} onClick={onClickCancel} />
        </div>
        <div className="selection-block">
          <div className="title-content">Banner</div>
          <div className="screen-dropdown">
            <Select
              name="screen"
              label={"Screen"}
              placeholder={"Select banner screen"}
              options={bannerScreenListDropDownOptions}
              onChange={(val) => onChangeBannerScreenOption(val)}
              isrequired={true}
              error={errors["screen"]}
            />
          </div>
          <div className="screen-dropdown">
            <Select
              name={"status"}
              className="custom-select-menu"
              label={"Status"}
              placeholder={"Please select status"}
              options={statusDropDownOptions}
              onChange={handleStatusChange}
              styles={{
                menuList: (baseStyles, state) => ({
                  ...baseStyles,
                  // height: "70px",
                  overflow: "auto",
                }),
              }}
              isrequired={true}
              error={errors["status"]}
            />
          </div>
        </div>
        <div className="action-block">
          <div className="action-wrapper">
            <ButtonView
              title="Cancel"
              styles={"light"}
              onClick={() => {
                history.push("/media/banner-management");
              }}
            />
          </div>
          <div className="action-wrapper">
            <ButtonView
              title="Submit"
              disabled={!fileInput}
              styles={"secondary"}
              onClick={onClickSubmit}
            />
          </div>
        </div>
      </div>
      <div className="add_banner--main-content-wrapper">
        <div className="left-side-content-block">
          <div className="banner-edit-block">{renderBannerContent()}</div>
        </div>
        <div className="right-side-content-block">
          <div className="banner-preview-block">
            {subscriptionList?.length > 0 && renderBannerPreviewContent()}
          </div>
          <div className="checklist-block">
            {subscriptionList?.length > 0 && renderCheckList()}
          </div>
        </div>
      </div>
      <ModalView
        show={showModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={modalTitle}
        children={renderEditBody()}
        footer={renderFooter()}
      />
      <ModalView
        show={showImageResolutionWarningModal}
        handleClose={() => {
          handleCloseImageResolutionWarningModal();
          handleDiscardFile();
        }}
        center={true}
        showCloseIcon={showImageResolutionWarningModal && true}
        title={"Attention"}
        children={renderImageResolutionWarningBody()}
        footer={renderImageResolutionFooter()}
      />
      <ModalView
        show={showColorModalOnClickIcon}
        handleClose={() => {
          handleOnClickCancelImageBackgroundColorModal();
        }}
        center={true}
        showCloseIcon={false}
        title={"Select Background Color"}
        children={renderImageBackgroundColorBody()}
        footer={renderImageBackgroundColorOnEditColorIconClickFooter()}
      />
    </div>
  );
};

export default AddBannerView;
